export default __webpack_public_path__ + "static/media/花瓣3.10169109.svg";